import moment from "moment";
import "moment-timezone";
import dateFormats from "./dateFormats";

// Server-computed schedule dates (e.g. Job.dateScheduled for cron jobs) represent a business-local
// point in time (Europe/Berlin) but are transmitted as UTC ISO strings. moment(date).format(...)
// would convert them to the *viewer's own browser/system timezone*, which only coincidentally
// matches Europe/Berlin - on a machine set to a different zone (e.g. UTC, as is common on dev/CI
// systems) this silently displays the wrong local time. Use this instead of formatDateTime when
// the value must always reflect Ald's Europe/Berlin business timezone, regardless of the viewer.
export default (date?: string | null): string => {
	if (!date) {
		return "";
	}

	return moment.tz(date, "Europe/Berlin").format(dateFormats.dateTime);
};
